import { CreateCreditNote, UpdateCreditNote } from "Listfunction";
import React, { Component } from "react";
import {
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Modal,
  Table,
} from "react-bootstrap";
import Button from "components/CustomButton/CustomButton.jsx";
import SweetAlert from "react-bootstrap-sweetalert";
import { ApprovedCreditNote, DownloadCreditNote } from "Listfunction";

class CreditNoteModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      referenceNote: "",
      pdfloading: false,
      creditNoteStatus: "DRAFT",
      creditNoteStatusError: null,
      created_At: "",
      basketValue: 0,
      creditNoteItems: [],
      basketValueError: null,
      error: null,
      hasCreditNote: false,
      catPkgDiscount: 0,
      pkgDiscountPercent: 0,
    };
    this.downloadCN = this.downloadCN.bind(this);
  }

  componentDidMount() {
    console.log(
      "creditNoteItem this.props.inputList",
      this.props.inputList,
      this.props.creditNoteData,
      this.props.pkgDiscount
    );
    let creditTotalValue = 0;
    let creditNoteStatus = "DRAFT";
    let referenceNote = "";
    let pkgDiscount = (100 - parseFloat(this.props.pkgDiscount)) / 100;

    const creditNoteItems = (this.props.inputList || []).map((item) => {
      let creditNoteQuantity = 0;
      if (!!this.props.creditNoteData) {
        creditNoteStatus = this.props.creditNoteData.status;
        referenceNote = this.props.creditNoteData.reference;
        const creditNoteItems =
          this.props.creditNoteData.credit_note_items || [];
        const creditNoteItem = creditNoteItems.find(
          (creditNoteItem) =>
            creditNoteItem.order_item_id === item.orderItemNumber
        );
        if (creditNoteItem) {
          creditNoteQuantity = creditNoteItem.quantity || 0;
        }

        this.setState({ hasCreditNote: true });
      }

      const amount =
        Number(item.unitprice || 0) * creditNoteQuantity * pkgDiscount;
      creditTotalValue = creditTotalValue + amount;

      return {
        order_item_id: item.orderItemNumber,
        item_code: item.medi_itemcode,
        item_description: item.medi_title,
        quantity: creditNoteQuantity,
        unit_price: item.unitprice,
        amount: amount,
        initialQuantity: item.quantity,
        quantity_per_box: item.quantity_per_box,
        quantity_type: item.quantity_type,
      };
    });
    this.setState({
      creditNoteItems: creditNoteItems,
      basketValue: creditTotalValue.toFixed(2),
      creditNoteStatus: creditNoteStatus,
      referenceNote: referenceNote,
      catPkgDiscount: pkgDiscount,
      pkgDiscountPercent: this.props.pkgDiscount,
    });
  }

  sendCreditNoteValue = () => {
    // console.log(this.props);
    let error = false;
    let basketValueError = "";

    const alertMsg = this.state.hasCreditNote
      ? this.state.creditNoteStatus === "APPROVED"
        ? "Are you sure you want to approve this credit note?"
        : "Are you sure you want to update this credit note?"
      : "Are you sure you want to credit on this order ?";

    const alertTitle = this.state.hasCreditNote
      ? this.state.creditNoteStatus === "APPROVED"
        ? "Approve Credit Note"
        : "Update Credit Note"
      : "Create Credit Note";

    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    if (
      Number(this.state.basketValue) === 0 ||
      this.state.basketValue === null
    ) {
      error = true;
      basketValueError = (
        <small className="text-danger">Return quantity required</small>
      );
      this.setState({ basketValueError: basketValueError });
    } else {
      const filteredCreditNoteItems = this.state.creditNoteItems.filter(
        (item) => item.quantity > 0
      );

      // console.log("items", filteredCreditNoteItems);

      const createCreditNoteBody = {
        order_id: this.props.orderId,
        reference: this.state.referenceNote,
        status: this.state.creditNoteStatus,
        cn_id: !!this.props.creditNoteData
          ? this.props.creditNoteData.cn_id
          : null,
        total_amount: this.state.basketValue,
        data: filteredCreditNoteItems.map((x) => ({
          order_item_id: x.order_item_id,
          item_code: x.item_code,
          item_description: x.item_description,
          quantity: x.quantity,
          unit_price: x.unit_price,
          amount: x.amount,
        })),
      };

      // console.log("body", createCreditNoteBody);

      this.props.setAlert(
        <SweetAlert
          title={alertTitle}
          warning
          style={{ display: "block", marginTop: "-100px" }}
          onConfirm={() =>
            !!this.props.creditNoteData
              ? this.confirmUpdateCreditNoteValue(obj, createCreditNoteBody)
              : this.confirmSendCreditNoteValue(obj, createCreditNoteBody)
          }
          onCancel={this.hideAlert}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="OK"
          cancelBtnText="Cancel"
          showCancel
        >
          {alertMsg}
        </SweetAlert>
      );
    }
  };

  confirmSendCreditNoteValue = (obj, createCreditNoteBody) => {
    this.props.setLoading(true);
    this.props.setAlert(null);
    CreateCreditNote(obj, createCreditNoteBody)
      .then((res) => {
        this.props.setLoading(true);
        this.props.setAlert(null);
        this.props.setCreditNote(false);
        window.location.reload();
      })
      .catch((error) => {
        this.props.setLoading(false);
        console.error("Error sending credit note", error);
      });
  };

  downloadCN(cn_id) {
    console.log("------cnid", cn_id);
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ pdfloading: true, processing: false }, () => {
      DownloadCreditNote(cn_id, obj).then((res) => {
        this.setState({ pdfloading: false });
        var payload = res.data.data.pdf_url;
        const link = document.createElement("a");
        link.href = payload;
        link.target = "_blank";
        link.setAttribute("download", cn_id + ".pdf");
        // document.body.appendChild(link)
        link.click();
        // this.setState({
        //   viewinvoice : ddata
        // })
        this.setState({ pdfloading: false, processing: true });
      });
    });
  }

  confirmUpdateCreditNoteValue = (obj, createCreditNoteBody) => {
    this.props.setLoading(true);
    this.props.setAlert(null);
    UpdateCreditNote(obj, createCreditNoteBody)
      .then((res) => {
        this.props.setLoading(true);
        this.props.setAlert(null);
        this.props.setCreditNote(false);
        window.location.reload();
      })
      .catch((error) => {
        this.props.setLoading(false);
        console.error("Error sending credit note", error);
      });
  };

  approvedCreditNote = (obj, cn_id) => {
    this.props.setLoading(true);
    this.props.setAlert(null);
    ApprovedCreditNote(obj, cn_id)
      .then((res) => {
        this.props.setLoading(true);
        this.props.setAlert(null);
        this.props.setCreditNote(false);
        window.location.reload();
      })
      .catch((error) => {
        this.props.setLoading(false);
        console.error("Error sending credit note", error);
      });
  };

  hideAlert = () => {
    this.props.setAlert(null);
  };

  creditNoteOnChange = (event) => {
    //important
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  };

  selectCreditNoteStatus(value) {
    this.setState({ creditNoteStatus: value });
  }

  handleInputCreditNoteChange = (e, row, index) => {
    console.log("----", this.state.catPkgDiscount);
    const { value } = e.target;
    const list = [...this.state.creditNoteItems];
    let creditTotalValue = 0;
    if (value === "" || isNaN(value)) {
      const updatedCreditNoteItems = list.map((orderItem, i) => {
        if (i === index && row.item_code === orderItem.item_code) {
          return {
            ...orderItem,
            quantity: 0,
            amount: 0,
          };
        }
        const amount =
          orderItem.unit_price * orderItem.quantity * this.state.catPkgDiscount;

        creditTotalValue += amount;
        return orderItem;
      });

      this.setState({
        creditNoteItems: updatedCreditNoteItems,
        basketValue: creditTotalValue,
      });
      return;
    }

    const parsedValue = parseInt(value, 10);
    const validValue = Math.min(Math.max(parsedValue, 0), row.initialQuantity);
    const updatedCreditNoteItems = list.map((orderItem, i) => {
      if (i === index && row.item_code === orderItem.item_code) {
        const amount =
          orderItem.unit_price * validValue * this.state.catPkgDiscount;
        creditTotalValue += amount;
        return {
          ...orderItem,
          quantity: validValue,
          amount: amount,
        };
      }
      const amount =
        orderItem.unit_price * orderItem.quantity * this.state.catPkgDiscount;
      creditTotalValue += amount;
      return orderItem;
    });

    this.setState({
      creditNoteItems: updatedCreditNoteItems,
      basketValue: creditTotalValue,
      basketValueError: null,
    });
  };

  render() {
    const user = JSON.parse(localStorage.getItem("user"));
    const isSuperAdmin = user.role === 1;
    const isDisabledInputFieldsAndSubmit =
      this.props.creditNoteData &&
      this.props.creditNoteData.status === "APPROVED";
    const isCreditNoteStatus = this.state.creditNoteStatus === "APPROVED";
    const isCreditNoteHas = this.props.creditNoteData === null;

    return (
      <Modal
        show={this.props.creditNote}
        onHide={() => this.props.setCreditNote(false)}
        bsSize="large"
        allowFullScreen
        id="increaseWidth"
        style={{ width: "100% !important" }}
      >
        <Modal.Header style={{ display: "flex", flexDirection: "column" }}>
          <Modal.Title
            style={{
              marginTop: "5px",
              display: "flex",
              justifyContent: "space-between",
              borderBottom: "1px solid black",
              padding: "0px 10px",
            }}
          >
            <p style={{ fontSize: "18px", fontWeight: "bold" }}>
              {this.props.creditNoteData
                ? this.props.creditNoteData.status === "DRAFT"
                  ? "Edit "
                  : "View "
                : "Create "}
              Credit Note
              {this.props.creditNoteData
                ? ` - #${this.props.creditNoteData.cn_id} `
                : ""}
            </p>
            <p
              style={{ fontSize: "18px", fontWeight: "bold" }}
            >{`Order ID - #${this.props.orderId}`}</p>
          </Modal.Title>
          <div
            style={{
              display: "flex",
              gap: "10px",
              padding: "20px 10px 0px 10px",
            }}
          >
            <div
              style={{
                display: "flex",
              }}
            >
              <FormGroup>
                <ControlLabel>Reference</ControlLabel>
                <FormControl
                  type="text"
                  name="referenceNote"
                  value={this.state.referenceNote || ""}
                  onChange={this.creditNoteOnChange}
                  placeholder="Enter Reference"
                  disabled={isDisabledInputFieldsAndSubmit}
                ></FormControl>
              </FormGroup>
            </div>
            <Col
              md={3}
              sm={4}
              lg={3}
              xs={12}
              className="fl_status_dropdown"
              style={{
                paddingTop: "4px",
                flexBasis: "content",
              }}
            >
              <ControlLabel>Credit Note Status</ControlLabel>
              <select
                name="creditNoteStatus"
                className="form-control"
                value={this.state.creditNoteStatus}
                disabled={
                  isDisabledInputFieldsAndSubmit || !this.props.creditNoteData
                }
                onChange={(event) => {
                  const value = event.target.value;
                  this.setState({
                    creditNoteStatus: value,
                    creditNoteStatusError: null,
                  });
                }}
              >
                <option value="DRAFT">Draft</option>
                <option value="APPROVED">Approved</option>
              </select>
              {this.state.creditNoteStatusError}
            </Col>
          </div>
        </Modal.Header>
        <Modal.Body style={{ overflowY: "scroll", height: "65vh" }}>
          <Table>
            <thead>
              <tr>
                <th style={{ paddingLeft: 0 }}>
                  <ControlLabel>Item Code</ControlLabel>
                </th>
                <th>
                  <ControlLabel>Item Name </ControlLabel>
                </th>
                <th>
                  <ControlLabel>Quantity</ControlLabel>
                </th>
                <th>
                  <ControlLabel>Return Quantity</ControlLabel>
                </th>
                <th>
                  <ControlLabel>Unit Price</ControlLabel>
                </th>
                <th>
                  <ControlLabel>Amount LKR </ControlLabel>
                </th>
              </tr>
            </thead>
            <tbody>
              {this.state.creditNoteItems.length > 0
                ? this.state.creditNoteItems.map((x, i) => (
                    <tr>
                      <td>{x.item_code}</td>
                      <td>{x.item_description}</td>
                      <td>{x.initialQuantity}</td>
                      <td>
                        <FormControl
                          style={{ width: "100px", textAlign: "center" }}
                          className="no-padding qty_imput"
                          name="quantity"
                          // min={0}
                          max={x.initialQuantity}
                          value={x.quantity}
                          disabled={isDisabledInputFieldsAndSubmit}
                          onChange={(e) =>
                            this.handleInputCreditNoteChange(e, x, i)
                          }
                          // placeholder="0"
                          // type="number"
                        />
                        {x.quantity_type === 1 ? x.quantity_per_box : ""}
                      </td>
                      <td>{x.unit_price}</td>
                      <td>{x.amount}</td>
                    </tr>
                  ))
                : ""}
            </tbody>
            <br />
            <br />
          </Table>
          <Col md={7} />
          <Col md={5} style={{ paddingRight: 0 }}>
            <div className="table-responsive">
              <table className="table">
                <tbody>
                  {this.state.pkgDiscountPercent !== 0 ? (
                    <tr>
                      <td>
                        <b>
                          This credit note has {this.props.pkgDiscount} %
                          package discount
                        </b>
                      </td>
                      <td></td>
                    </tr>
                  ) : (
                    ""
                  )}

                  <tr>
                    <td>
                      <b>Total</b>
                    </td>
                    <td>
                      {Number(this.state.basketValue).toFixed(2)}
                      <div style={{ display: "flex" }}>
                        {this.state.basketValueError}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Col>
        </Modal.Body>
        <Modal.Footer>
          <Col sm={12} md={12} xs={12} className="text-right">
            {this.state.hasCreditNote ? (
              <Button
                bsStyle="success"
                fill
                // disabled={!this.state.processing}
                onClick={this.downloadCN.bind(
                  this,
                  this.props.creditNoteData.cn_id
                )}
              >
                Download PDF
              </Button>
            ) : (
              ""
            )}

            {!isDisabledInputFieldsAndSubmit ? (
              this.state.creditNoteStatus === "APPROVED" ? (
                <Button
                  bsStyle="success"
                  fill
                  onClick={() => this.sendCreditNoteValue()}
                >
                  Save and Approve
                </Button>
              ) : (
                <Button
                  bsStyle="success"
                  fill
                  onClick={() => this.sendCreditNoteValue()}
                >
                  Save
                </Button>
              )
            ) : null}
            <Button
              bsStyle="danger"
              fill
              onClick={() => {
                this.props.setCreditNote(false);
              }}
            >
              Cancel
            </Button>
          </Col>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default CreditNoteModal;
